












import { Component, Prop, Vue } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformLogicJump } from '@/api/model/typeform/typeform-logic-jump'
import LogicJumpAction from '@/views/Company/Settings/Typeform/Forms/Detail/LogicJumpAction.vue'

@Component({
    components: {
        LogicJumpAction,
    },
})
export default class LogicJump extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly logicJump!: TypeformLogicJump
}
